/**
 * Sysadmin Catalog → Create-Agent chooser route — thin wrapper around
 * <AgentNew scope="sysadmin">.
 *
 * PR-B agent-new shared-component refactor (2026-05-12).
 * The entire chooser body lives in
 * `@/components/agent-new-shared/AgentNew.tsx`. This file only declares
 * the TanStack-Router file route. ALL mode-selector, Quick Create form,
 * and Import-JSON logic is shared with the tenant chooser route.
 *
 * Sysadmin-specific affordances (slug field, "Create System Agent"
 * title, sysadmin import placeholder, post-save navigation into the
 * builder editor) are gated via the sysadminAdapter — see
 * `AgentNew.tsx` for the canonical scope-deviation table and
 * `AgentNew.adapters.tsx` for the adapter contract.
 */
import { createFileRoute } from '@tanstack/react-router';
import { AgentNew } from '@/components/agent-new-shared/AgentNew';

export const Route = createFileRoute('/sysadmin/catalog/agents/new')({
  component: SysadminCreateAgentPage,
});

function SysadminCreateAgentPage() {
  return <AgentNew scope="sysadmin" />;
}
